import React from 'react';
import { Button, Box, IconButton, Typography } from '@mui/material';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useParams, useNavigate } from 'react-router-dom';

const Report3 = () => {
  const { reportId } = useParams();
  const navigate = useNavigate();
  
  const sampleReports = [
    {
      id: 1,
      title: "FRAX Report - Goldberry River-Daughter",
      patientName: "Goldberry River-Daughter",
    },
    {
      id: 2,
      title: "CAROC Report - Aragorn Son of Arathorn",
      patientName: "Aragorn Son of Arathorn",
    },
    {
      id: 3,
      title: "FRAX Report - Bilbette Baggins",
      patientName: "Bilbette Baggins",
    }
  ];
  
  const currentReport = sampleReports.find(r => r.id === parseInt(reportId)) || sampleReports[0];
  const currentIndex = sampleReports.findIndex(r => r.id === parseInt(reportId));
  
  const goToPreviousReport = () => {
    if (currentIndex > 0) {
      navigate(`/report/${sampleReports[currentIndex - 1].id}`);
    }
  };
  
  const goToNextReport = () => {
    if (currentIndex < sampleReports.length - 1) {
      navigate(`/report/${sampleReports[currentIndex + 1].id}`);
    }
  };
  
  return (
    <div style={{
      fontFamily: 'Arial, sans-serif',
      lineHeight: '1.4',
      margin: 0,
      padding: '20px',
      backgroundColor: '#ffffff',
      color: '#333',
      display: 'flex',
      justifyContent: 'center',
      '@media print': {
        padding: 0,
      },
    }}>
      <Box style={{
        maxWidth: '8.5in',
        width: '100%',
        backgroundColor: '#ffffff',
      }}>
        <Box style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          marginBottom: '20px',
          '@media print': {
            display: 'none',
          },
        }}>
          <Box style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <IconButton
              onClick={goToPreviousReport}
              disabled={currentIndex === 0}
              style={{ color: currentIndex === 0 ? '#ccc' : '#0a3d62' }}
            >
              <NavigateBeforeIcon />
            </IconButton>
            <Typography variant="body2" style={{ color: '#666' }}>
              {currentReport.title}
            </Typography>
            <IconButton
              onClick={goToNextReport}
              disabled={currentIndex === sampleReports.length - 1}
              style={{ color: currentIndex === sampleReports.length - 1 ? '#ccc' : '#0a3d62' }}
            >
              <NavigateNextIcon />
            </IconButton>
          </Box>
          
          <Box style={{ display: 'flex', gap: '10px' }}>
            <Button
              variant="outlined"
              onClick={() => navigate('/reports')}
              style={{ borderColor: '#0a3d62', color: '#0a3d62' }}
            >
              All Reports
            </Button>
          </Box>
        </Box>
        
        <table border="1" style={{
          width: '100%',
          borderCollapse: 'collapse',
          marginBottom: '20px',
        }}>
          <tbody>
            <tr>
              <td style={{verticalAlign: 'top', padding: '20px'}}>
                <div style={{marginTop: '0.125in', marginBottom: '0.125in'}}>
                  <h1 style={{margin: 0, fontSize: '24px', fontWeight: 'bold', textAlign: 'center'}}>C-Encode</h1>
                  <p style={{margin: '5px 0 0 0', fontSize: '14px', textAlign: 'center'}}>9131 Keele St, Unit A4, Vaughan, ON L4K 0G7</p>
                </div>
                
                <div style={{marginBottom: '30px'}}>
                  <div style={{
                    backgroundColor: '#f5f5f5',
                    border: '1px solid #ddd',
                    padding: '8px',
                    marginBottom: '10px',
                    fontSize: '12px',
                    lineHeight: '1.2',
                  }}>
                    <div style={{display: 'grid', gridTemplateColumns: '100px 1fr', gap: '5px', alignItems: 'center', marginBottom: '8px'}}>
                      <div style={{fontWeight: 'bold'}}>Patient:</div>
                      <div>Bilbette Baggins</div>
                    </div>
                    <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px'}}>
                      <div style={{display: 'grid', gridTemplateColumns: '100px 1fr', gap: '5px', alignItems: 'center'}}>
                        <div style={{fontWeight: 'bold'}}>Birth Date:</div>
                        <div>1944-10-15</div>
                        <div style={{fontWeight: 'bold'}}>Sex:</div>
                        <div>Female</div>
                      </div>
                      <div style={{display: 'grid', gridTemplateColumns: '100px 1fr', gap: '5px', alignItems: 'center'}}>
                        <div style={{fontWeight: 'bold'}}>Age:</div>
                        <div>81 years</div>
                        <div style={{fontWeight: 'bold'}}>Study Date:</div>
                        <div>2025-10-15</div>
                      </div>
                    </div>
                    <div style={{marginTop: '8px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px'}}>
                      <div style={{display: 'grid', gridTemplateColumns: '100px 1fr', gap: '5px', alignItems: 'center'}}>
                        <div style={{fontWeight: 'bold'}}>Ordered By:</div>
                        <div>Dr. Elrond of Rivendell</div>
                        <div style={{fontWeight: 'bold'}}>Reported By:</div>
                        <div>Dr. Galadriel of Lothlórien</div>
                      </div>
                      <div style={{display: 'grid', gridTemplateColumns: '100px 1fr', gap: '5px', alignItems: 'center'}}>
                        <div style={{fontWeight: 'bold'}}>CC:</div>
                        <div>Dr. Gandalf The White</div>
                        <div style={{fontWeight: 'bold'}}>Report Date:</div>
                        <div>2025-10-15</div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div style={{marginTop: '0.125in', marginBottom: '25px'}}>
                  
                  <div style={{marginTop: '15px', fontSize: '14px', lineHeight: '1.6'}}>
                    <h3 style={{fontSize: '16px', fontWeight: 'bold', marginBottom: '10px', color: '#0a3d62', marginTop: '20px'}}>History:</h3>
                    <p>A repeat bone density study was obtained on this 81 year old FEMALE. There is no reported history of low trauma fractures or prolonged systemic glucocorticoid therapy. Current smoking is reported. Bone active drug therapy is not reported. Body weight is 68.2 kg, height is 162 cm.</p> 
                    <h3 style={{fontSize: '16px', fontWeight: 'bold', marginBottom: '10px', color: '#0a3d62', marginTop: '20px'}}>Bone Mineral Density Data:</h3>
                    <p>Compared with previous examination on September 10, 2015.</p>

                    <p>LUMBAR SPINE (L1-L3) = 1.009 g/cm2. T-score = -1.4.<br/>This value has DECREASED by 0.024 g/cm2 (-2.3%) compared to the previous.</p>
                    
                    <p>LEFT FEMORAL NECK = 0.692 g/cm2. T-score = -2.5.</p>
                    
                    <p>LEFT TOTAL PROXIMAL FEMUR = 0.678 g/cm2. T-score = -2.6.<br/>This value has DECREASED by 0.139 g/cm2 (-17.0%) compared to the previous.</p>
                    
                    <h3 style={{fontSize: '16px', fontWeight: 'bold', marginBottom: '10px', color: '#0a3d62', marginTop: '20px'}}>Diagnostic Category:</h3>
                    <p>Osteoporosis</p>
                    
                    <h3 style={{fontSize: '16px', fontWeight: 'bold', marginBottom: '10px', color: '#0a3d62', marginTop: '20px'}}>10-Year Fracture Risk (FRAX):</h3>
                    <p>The estimated 10-year probability of a major osteoporotic fracture is 18%. However, fracture risk is likely underestimated due to an osteoporotic T-score at the lumbar spine, femoral neck or total hip, which is not accounted for in FRAX.</p>

                    <h3 style={{fontSize: '16px', fontWeight: 'bold', marginBottom: '10px', color: '#0a3d62', marginTop: '20px'}}>Limitations:</h3>
                    <p>Vertebra(e) has/have been excluded from analysis as the T-score(s) is/are at least one standard deviation greater than the T-score of the vertebra with the next highest value.</p>
                    
                    
                    <h3 style={{fontSize: '16px', fontWeight: 'bold', marginBottom: '10px', color: '#0a3d62', marginTop: '20px'}}>Interval Change</h3>
                    
                    <p>Lumbar Spine: The area within the region of interest COULD NOT be duplicated within 2%. Current results CANNOT be accurately compared with previous.<br/>Left Total Proximal Femur: Statistically SIGNIFICANT interval DECREASE. </p>

                    <h3 style={{fontSize: '16px', fontWeight: 'bold', marginBottom: '10px', color: '#0a3d62', marginTop: '20px'}}>Recommendations:</h3>

                    <p>Bone-active drug therapy is recommended as per Osteoporosis Canada guidelines.</p>

                    <p>Non-pharmacological and lifestyle measures are applicable to all patients. All patients should ensure an adequate intake of dietary calcium (1200 mg/d) and vitamin D (800-2000 IU daily). Regular weight-bearing exercise and fall prevention strategies should be encouraged.</p>
                    
                    <p>It would be appropriate to consider a lateral x-ray of the thoracic and lumbar spine from T4-L4 to assess for possible compression fractures. The presence of a compression fracture could change management strategies.</p>

                    <p>Clinical correlation and investigation as appropriate are recommended to assess for causes of bone loss.</p>
                    
                    <h3 style={{fontSize: '16px', fontWeight: 'bold', marginBottom: '10px', color: '#0a3d62', marginTop: '20px'}}>Follow Up:</h3>
                    <p>Follow-up suggested in 1-2 years, given significant interval bone loss.</p>
                    
                    <div><strong>LSC (least significant change) at C-Encode:</strong><br/>Lumbar Spine - 0.031 gm/cm²<br/>Total Hip - 0.019 gm/cm²</div>
                  </div>
                </div>
                
                <div style={{marginTop: '40px', textAlign: 'center', fontSize: '12px', color: '#666'}}>
                  <p>Report generated on: 2025-10-15</p>
                  <p>Page 1 of 1</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </Box>
    </div>
  );
};

export default Report3;

